import { render, staticRenderFns } from "./VerticalRuler.vue?vue&type=template&id=2e629300&scoped=true"
import script from "./VerticalRuler.vue?vue&type=script&lang=js"
export * from "./VerticalRuler.vue?vue&type=script&lang=js"
import style0 from "./VerticalRuler.vue?vue&type=style&index=0&id=2e629300&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e629300",
  null
  
)

export default component.exports